/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";

const VerticalSelectField = ({
  input,
  meta: { touched, error },
  label,
  children
}) => {
  const invalid = touched && error ? "invalid" : "";
  return (
    <div className="form-group">
      <label htmlFor={input.name}>{label}</label>
      <select {...input} className={`form-control ${invalid}`}>
        {children}
      </select>
    </div>
  );
};
VerticalSelectField.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }).isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.node
};

export default VerticalSelectField;



// WEBPACK FOOTER //
// ./src/forms/fields/VerticalSelectField.js